import * as React from 'react';

import { cn } from '../../lib/cn';

/** Bordered 16px card used down the detail rail. */
export const KitCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col gap-3 rounded-[16px] border border-dusq-border p-3', className)}
    {...props}
  />
));
KitCard.displayName = 'KitCard';

/** Card heading plus the hairline the design draws under it. */
export const KitCardTitle = ({ className, children, trailing, ...props }) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center justify-between gap-2">
      <span
        className={cn('font-dusq text-[12px] font-medium text-dusq-text', className)}
        {...props}
      >
        {children}
      </span>
      {trailing}
    </div>
    <span className="h-[0.4px] w-full bg-dusq-divider" />
  </div>
);

/** Label on the left, value on the right: the rail's whole vocabulary. */
export const KitRow = ({ label, value, tone }) => (
  <div className="flex items-center justify-between gap-3">
    <span className="font-dusq text-[12px] text-dusq-grey600">{label}</span>
    <span
      className={cn(
        'text-right font-dusq text-[11.5px] font-bold',
        tone === 'positive' && 'text-dusq-positive-value',
        tone === 'warning' && 'text-dusq-warning',
        tone === 'negative' && 'text-dusq-negative',
        !tone && 'text-dusq-text'
      )}
    >
      {value}
    </span>
  </div>
);
